import { Injectable } from '@angular/core';
import { Model, ModelFactory, } from '@socrates/common';
import { SearchResponseInfo } from './SearchResponseInfo';

@Injectable()
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export class TestRestSearchRepo<T extends Model> {

	search<T extends Model>(url: string, params: any, modelFactory: ModelFactory<T>): Promise<SearchResponseInfo<T>> {
		const deferred = new Promise<SearchResponseInfo<T>>((resolve) => {

			// need to set the model factory in the service to a derivation of its factory that will create test records
			const resultRows: T[] = [];
			const resultsPerPage: number = parseInt(params['results_per_page'], 10);
			for (let li = 0; li < resultsPerPage; li++) {
				resultRows.push(modelFactory.createNew({ }));
			}
			const page: number = parseInt(params['page'], 10);
			const searchResponse: SearchResponseInfo<T> = new SearchResponseInfo<T>(page, 1000, resultsPerPage, resultRows);
			resolve(searchResponse);
		});
		return deferred;
	}
}
